module.exports = __webpack_public_path__ + "img/cloud.4dc8014e.png";